import { Icons } from "assets";
import { routeConstant } from "shared/routes/routeConstant";

const sideBarConstants: SideBarItemsType[] = [
  {
    title: "Main",
    paths: [
      {
        path: routeConstant.dashboard.path,
        title: routeConstant.dashboard.title,
        Icon: Icons.MenuIcon,
      },
      {
        path: routeConstant.users.path,
        title: routeConstant.users.title,
        Icon: Icons.Users,
      },
      {
        path: routeConstant.flaggedUsers.path,
        title: routeConstant.flaggedUsers.title,
        Icon: Icons.FlagOutline,
      },
      {
        path: routeConstant.products.path,
        title: routeConstant.products.title,
        Icon: Icons.PortfolioIcon,
      },
      {
        title: "Transactions",
        Icon: Icons.Payment,
        subPaths: [
          {
            title: routeConstant.paymentTransactions.title,
            path: routeConstant.paymentTransactions.path,
            Icon: Icons.Payment,
          },
          {
            title: routeConstant.subcriptionTransactions.title,
            path: routeConstant.subcriptionTransactions.path,
            Icon: Icons.Payment,
          },
          {
            title: routeConstant.featureTransactions.title,
            path: routeConstant.featureTransactions.path,
            Icon: Icons.Payment,
          },
        ],
      },
      {
        path: routeConstant.powerSellerRequests.path,
        title: routeConstant.powerSellerRequests.title,
        Icon: Icons.Lock,
      },
      {
        path: routeConstant.userReport.path,
        title: routeConstant.userReport.title,
        Icon: Icons.Bill,
      },
      {
        path: routeConstant.productReport.path,
        title: routeConstant.productReport.title,
        Icon: Icons.Bill,
      },
      {
        path: routeConstant.brands.path,
        title: routeConstant.brands.title,
        Icon: Icons.JobApplicationIcon,
      },
      {
        path: routeConstant.images.path,
        title: routeConstant.images.title,
        Icon: Icons.Images,
      },
      {
        path: routeConstant.advertisement.path,
        title: routeConstant.advertisement.title,
        Icon: Icons.PortfolioIcon,
      },
      {
        path: routeConstant.blogs.path,
        title: routeConstant.blogs.title,
        Icon: Icons.PortfolioIcon,
      },
      {
        path: routeConstant.faqs.path,
        title: routeConstant.faqs.title,
        Icon: Icons.CalendarBlank,
      },
      {
        path: routeConstant.policy.path,
        title: routeConstant.policy.title,
        Icon: Icons.JobApplicationIcon,
      },
      {
        path: routeConstant.testimonials.path,
        title: routeConstant.testimonials.title,
        Icon: Icons.Testimonial,
      },

      {
        path: routeConstant.supportMessages.path,
        title: routeConstant.supportMessages.title,
        Icon: Icons.Chat,
      },
    ],
  },
  {
    title: "Help",
    paths: [
      {
        path: routeConstant.settings.path,
        title: routeConstant.settings.title,
        Icon: Icons.Settings,
      },
    ],
  },
];

const BrandTabs: { label: string; value: string }[] = [
  {
    label: "ATV",
    value: "ATV",
  },
  {
    label: "UTV",
    value: "UTV",
  },
  {
    label: "Snowmobile",
    value: "Snowmobile",
  },
  {
    label: "Watercraft",
    value: "Watercraft",
  },
];

export { sideBarConstants, BrandTabs };
